import styled from 'styled-components/macro';

export const RosterRollover = styled.div({
  maxWidth: '920px',
  width: '100%',
});
